// CFD status metadata — FE-037 / spec §7.0.11.
//
// Stable order matches the spec's stacked layout (bottom → top):
//   done, in_review, in_progress, ready_for_work, backlog, cancelled.
// Reverse the array when feeding ECharts series so the visual stack
// reads from "closed" at the bottom to "still in flight" up top with
// cancelled as a small terminal band above everything else.

import type { CfdStatus } from "@/features/dashboard";


export interface CfdStatusMeta {
  /** Visible status name. */
  label: string;
  /** Tailwind background class for the legend swatch. */
  swatch: string;
  /** ECharts ``itemStyle.color`` token. Resolved from the design
   * system colour ramp at runtime; we match the swatch by name so a
   * theme tweak only has to land in one place. */
  fill: string;
}


export const CFD_STATUS_ORDER: CfdStatus[] = [
  "done", "in_review", "in_progress",
  "ready_for_work", "backlog", "cancelled",
];


// Resolved from src/design-system/tokens/colors.ts. ECharts can't read
// CSS variables in happy-dom, so we hard-code the same hex the
// Tailwind classes produce. If colors.ts changes, update this map.
export const CFD_STATUS_META: Record<CfdStatus, CfdStatusMeta> = {
  done:           { label: "Done",        swatch: "bg-sage",   fill: "#6B8E7F" },
  in_review:      { label: "In review",   swatch: "bg-gold",   fill: "#D9A91E" },
  in_progress:    { label: "In progress", swatch: "bg-teal",   fill: "#1F4E4A" },
  ready_for_work: { label: "Ready for work", swatch: "bg-teal-tint", fill: "#D5E0DD" },
  backlog:        { label: "Backlog",     swatch: "bg-recessed", fill: "#EFEBE0" },
  cancelled:      { label: "Cancelled",   swatch: "bg-ember",  fill: "#C76B3A" },
};
